import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Checkbox } from "primereact/checkbox";
import { RadioButton } from "primereact/radiobutton";
import { InputText } from 'primereact/inputtext';
import 'primeicons/primeicons.css';
import Alertas from "../../alertas";

function Violencias({ setFraseTopo, setStage, violeciasSofridas, periodoSofrido, frequenciaSofrida, outraFrequencia, setViolenciasSofridas, setPeriodoSofrido, setFrequenciaSofrida, setOutraFrequencia }) {

    const opcoesViolencia = [
        { key: '1', name: 'Teve acesso negado a recursos básicos, como assistência médica, comida ou dinheiro.' },
        { key: '2', name: 'Foi forçada a ficar sozinha por um longo período ou impedida de se comunicar com amigos e familiares.' },
        { key: '3', name: 'Ofensa sexual ou tentativa forçada de manter relação sexual quando você não queria' },
        { key: '4', name: 'Tapa, batida, empurrão, puxão de cabelo ou chute' },
        { key: '5', name: 'Insulto, humilhação ou xingamento ou perseguição' },
        { key: '6', name: 'Ameaça verbal' },
        { key: '7', name: 'Espancamento ou tentativa de estrangulamento' },
        { key: '8', name: 'Ameaça com faca ou arma de fogo' },
        { key: '9', name: 'Esfaqueamento ou tiro' },
        { key: '10', name: 'Queimadura' },
        { key: '11', name: 'Proibiu de trabalhar' },
        { key: '12', name: 'Destruição de objetos ou documentos' },
        { key: '13', name: 'Retenção/tomada de patrimônio (bens móveis e imóveis)' },
        { key: '14', name: 'Não sofri nenhuma das violências acima' },
    ];

    const opcoesPeriodo = [
        { key: '1', name: 'Há menos de 12 meses' },
        { key: '2', name: 'Há mais de 12 meses' },
        { key: '3', name: 'Não sofri nenhuma das violências da pergunta anterior' },
    ];

    const opcoesFrequencia = [
        { key: '1', name: 'Apenas 01 (uma) vez' },
        { key: '2', name: 'Algumas vezes' },
        { key: '3', name: 'Sempre' },
        { key: '4', name: 'Não sofri nenhuma das violências da pergunta anterior' },
        { key: '5', name: 'Outros' },
    ];

    useEffect(() => {
        setFraseTopo("Sua voz tem poder, não se cale!");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    function verificacao(step) {
        if (frequenciaSofrida.key == '5') {
            if (outraFrequencia) {
                setStage(step)
            } else{
                Alertas.atencao('Adicione a descrição na opção "Outros".');
            } 
        } else {
            setStage(step)
        }
    }

    const onViolenciasChange = (e) => {
        let _selectedCategories = [...violeciasSofridas];

        if (e.checked)
            _selectedCategories.push(e.value);
        else
            _selectedCategories = _selectedCategories.filter(category => category.key !== e.value.key);

        setViolenciasSofridas(_selectedCategories);
    };

    return (
        <div className="app-main-mulher">
            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Você sofreu alguma dessas violências praticada pela pessoa envolvida no conflito familiar em relação a qual você está buscando atendimento na Defensoria Pública? </strong></p>
                        <p><strong>Marque TODAS que se aplicam</strong></p>

                        <div>
                            {opcoesViolencia.map((category) => {
                                return (
                                    <div key={category.key} className="item-check-mulher">
                                        <Checkbox inputId={category.key} name="category" value={category} onChange={onViolenciasChange} checked={violeciasSofridas.some((item) => item.key === category.key)} />
                                        <label htmlFor={category.key}>
                                            {category.name}
                                        </label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Há quanto tempo as violências ocorreram?</strong></p>
                        <div>
                            {opcoesPeriodo.map((category) => {
                                return (
                                    <div key={category.key} className="item-check-mulher">
                                        <RadioButton inputId={category.key} name="category" value={category} onChange={(e) => {setPeriodoSofrido(e.value);console.log(periodoSofrido)}} checked={periodoSofrido.key === category.key} />
                                        <label htmlFor={category.key} className="ml-2">{category.name}</label>
                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>

            <div className="main-card-mulher">
                <div className="card-form card-form-mulher">
                    <div>
                        <p className="labels"><strong>Com que frequência?</strong></p>
                        <div>
                            {opcoesFrequencia.map((category) => {
                                return (
                                    <div key={category.key} className="item-check-mulher">
                                        <RadioButton inputId={category.key} name="category" value={category} onChange={(e) => setFrequenciaSofrida(e.value)} checked={frequenciaSofrida.key === category.key} />
                                        <label htmlFor={category.key} className="ml-2">{category.name}</label>
                                    </div>
                                );
                            })}
                        </div>
                        {
                            frequenciaSofrida.key == '5' ?
                                <div className="card-form-a">
                                    <p className="labels">Outros <span className="pink">*</span> </p>
                                    <InputText value={outraFrequencia} onChange={(e) => setOutraFrequencia(e.target.value)} />
                                </div>
                                : 
                                <div className="card-form-a desativado">
                                    <p className="labels">Outros <span className="pink">*</span> </p>
                                    <InputText disabled value={outraFrequencia} />
                                </div>
                        }
                    </div>
                </div>
            </div>




            <div className="card-rodape-mulher">
                <Button
                    label="Voltar"
                    className="btn-1-mulher"
                    onClick={() => {
                        verificacao(2);
                    }}
                />
                <Button
                    style={{ marginLeft: "10px" }}
                    label="Próximo"
                    className="btn-1-mulher"
                    onClick={() => {
                        verificacao(4);
                    }}
                />
            </div>
        </div>

    );
}

export default Violencias;
